export default __webpack_public_path__ + "static/media/kw.12346d8b.svg";